<template>
  <div class="container">
    <CommonBreadcrumb class="bread_block" /> 
    <div class="main_title">
      <h1 class="mb-0 font-active">Book An Appointment</h1>
      <p class="mb-0">Your {{ $t('jewelry') }} Buying Experience, <span>Elevated.</span></p>
      <p class="mb-0 mt-3" v-if="$country.is_india">
        ‘Book My Appointment’ allows you to schedule personalised consultations with our expert gemologists. Whether you're looking for advice on choosing the ideal diamond or discussing custom designs, we ensure a dedicated one-on-one session to address your distinct preferences and requirements.
      </p>
    </div>

    <div class="banner text-center">
      <picture v-if="$country.is_india">
        <source media="(min-width: 768px)" width="1220" height="424" type="image/webp" srcset="~/assets/appointment/india/banner.webp">
        <source media="(min-width: 768px)" width="1220" height="424" type="image/jpeg" srcset="~/assets/appointment/india/banner.jpg">
        <source media="(max-width: 767px)" width="767" height="450" type="image/webp" srcset="~/assets/appointment/india/banner_mobile.webp">
        <source media="(max-width: 767px)" width="767" height="450" type="image/jpeg" srcset="~/assets/appointment/india/banner_mobile.jpg">
        <img width="1220" height="424" type="image/jpeg" src="~/assets/appointment/india/banner.jpg" alt="Book Appointments India">
      </picture>
      <picture v-else>
        <source media="(min-width: 768px)" width="1220" height="424" type="image/webp" srcset="~/assets/appointment/banner.webp">
        <source media="(min-width: 768px)" width="1220" height="424" type="image/jpeg" srcset="~/assets/appointment/banner.jpg">
        <source media="(max-width: 767px)" width="767" height="450" type="image/webp" srcset="~/assets/appointment/banner_mobile.webp">
        <source media="(max-width: 767px)" width="767" height="450" type="image/jpeg" srcset="~/assets/appointment/banner_mobile.jpg">
        <img width="1220" height="424" type="image/jpeg" src="~/assets/appointment/banner.jpg" class="radious_eight" alt="Book Appointments">
      </picture>
    </div>

    <div class="row appoint_type_block">
      <div class="col-md-6 col-12">
        <div class="appoint_type">
          <h3 class="mb-0 font-active">Office</h3>
          <p class="mb-0" v-if="$country.is_india">
            Take a step beyond the screen and into Friendly Diamonds’ Mumbai office, where our experts await to guide you in finding the perfect diamond. Your journey to timeless elegance begins with personal advice and hands-on assistance. Let us make your diamond buying experience truly extraordinary!
          </p>
          <p class="mb-0" v-else>
            Step beyond the screen and into Friendly Diamonds’ New York office, where our experts await to guide you in finding the perfect diamond or jewelry piece. Experience personalized advice and hands-on assistance, starting your journey to timeless elegance.
          </p>
          <CommonBasePrimary @click="showModal('office')" data-bs-toggle="modal" data-bs-target="#appointmentModal">Visit us</CommonBasePrimary>
        </div>
      </div>
      <div class="col-md-6 col-12 mx-auto">
        <div class="appoint_type">
          <h3 class="mb-0 font-active">Virtual</h3>
          <p class="mb-0" v-if="$country.is_india">
            Friendly Diamonds provides a pleasant virtual experience by offering one-on-one video consultations for personalised jewellery discussions. This allows you to engage with expert jewellers within the comfort of your own space, ensuring a tailored and convenient consultation process.
          </p>
          <p class="mb-0" v-else>
            Bring the Friendly Diamonds experience to the comfort of your home with a free one-on-one video consultation with our diamond and {{ $t('jewelry') }} expert to learn about our products.
          </p>
          <CommonBasePrimary @click="showModal('virtual')" data-bs-toggle="modal" data-bs-target="#appointmentModal">Book a virtual appointment</CommonBasePrimary>
        </div>
      </div>
    </div>

    <div class="row services_block">
      <div class="col-md-12 col-12">
        <h2 class="font-active">Services</h2>
      </div>
      <div class="col-md-4 col-12 text-center service_box">
        <picture>
          <source width="352" height="209" type="image/webp" srcset="~/assets/appointment/diamond_inspection.webp">
          <img width="352" height="209" type="image/jpeg" src="~/assets/appointment/diamond_inspection.jpg" alt="Real-Time Diamond Inspection" class="radious_eight">
        </picture>
        <h4 class="my-4 px-2 font-active">Real-Time <br> Diamond Inspection</h4>
        <p class="px-2" v-if="$country.is_india">View a wide range of diamonds available online in super zoom magnification or view them in person by booking an appointment at our Mumbai office.</p>
        <p class="px-2" v-else>View a wide range of diamonds available online in super zoom magnification or view them in person by booking an appointment at our New York office.</p>
      </div>
      <div class="col-md-4 col-12 text-center service_box">
        <picture>
          <source width="352" height="209" type="image/webp" srcset="~/assets/appointment/education.webp">
          <img width="352" height="209" type="image/jpeg" src="~/assets/appointment/education.jpg" alt="Education" class="radious_eight">
        </picture>
        <h4 class="my-4 px-2 font-active">Education</h4>
        <p class="px-2" v-if="$country.is_india">Our personalised session offers a comprehensive understanding of lab diamonds to all customers, guiding them towards making the right purchase with full confidence and knowledge.</p>
        <p class="px-2" v-else>Our knowledgeable team provides tailored advice, ensuring that every piece you choose is a perfect reflection of your style and preferences.</p>
      </div>
      <div class="col-md-4 col-12 text-center service_box">
        <picture>
          <source width="352" height="209" type="image/webp" srcset="~/assets/appointment/recommendation.webp">
          <img width="352" height="209" type="image/jpeg" src="~/assets/appointment/recommendation.jpg" alt="Recommendation" class="radious_eight">
        </picture>
        <h4 class="my-4 px-2 font-active">Recommendation</h4>
        <p class="px-2" v-if="$country.is_india">Our knowledgeable team provides tailored advice, ensuring that every piece you choose is a perfect reflection of your style and preferences.</p>
        <p class="px-2" v-else>Enjoy a curated experience based on your style, preferences and {{ $t('jewelry') }} of choice. Get product recommendations, and all questions related to them resolved.</p>
      </div>
    </div>

    <FaqDynamicFaq />
    <Teleport  to="#teleports">
      <div class="modal fade" data-bs-backdrop="true" id="appointmentModal" tabindex="-1" aria-labelledby="example" aria-hidden="true" ref="myModalRef">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                    <div class="modal-header title_block">
                        <h3 v-if="appointType === 'office'" class="modal-title" id="exampleModalLabel">Book Office Appointment</h3>
                        <h3 v-if="appointType === 'virtual'" class="modal-title" id="recipient-name">Book Virtual Appointment</h3>
                        <span data-bs-dismiss="modal" aria-label="Close"><SvgHeaderSvg :type="'close'" class="largesvg"/></span>
                    </div>
                  <div class="modal-body">
                      <div v-if="appointType === 'office'">
                        <div v-if="!isOfficeCalendlyLoaded" class="d-flex justify-content-center mt-3 spinner">
                          <div class="spinner-border" role="status"></div>
                        </div>
                        <div  id="calendly_office"></div>
                      </div>
                      <div v-if="appointType === 'virtual'">
                        <div v-if="!isVirtualCalendlyLoaded" class="d-flex justify-content-center mt-3 spinner">
                          <div class="spinner-border" role="status"></div>
                        </div>
                        <div id="calendly_virtual"></div>
                      </div>
                  </div>
                </div>
            </div>
      </div>
    </Teleport>
  </div>
</template>


<script setup>
useFetchMeta( useNuxtApp(), useRuntimeConfig() );

const appointType = ref('');
const isOfficeCalendlyLoaded = ref(false);
const isVirtualCalendlyLoaded = ref(false);
const is_event_type_viewed = ref(false);
const is_event_scheduled = ref(false);
const { $country, $appointmentInitiateGtag, $appointmentCreationGtag, $appointmentSucessGtag } = useNuxtApp();
const myModalRef = ref(null);


useHead({
  script: [
    {
      src: 'https://assets.calendly.com/assets/external/widget.js',
      async: true,
    },
  ],
});

const showModal = (type) => {
  appointType.value = type;
  if (type === 'office') {
    isOfficeCalendlyLoaded.value = false;
  } else if (type === 'virtual') {
    isVirtualCalendlyLoaded.value = false;
  }
  setupCalendly(type);
};

const mountCalendly = (type) => {
  if (window.Calendly === undefined) {
    return false;
  }

  let officeUrl = 'https://calendly.com/friendlydiamonds/office-appointment';
  let virtualUrl = 'https://calendly.com/friendlydiamonds/book-a-virtual-appointment';

  if ($country.location === 'IN') {
    officeUrl = 'https://calendly.com/india-2vi/virtual-appointment';
    virtualUrl = 'https://calendly.com/india-2vi/virtual-appointment';
  }

  if (type === 'office') {
    Calendly.initInlineWidget({
      url: officeUrl,
      parentElement: document.getElementById('calendly_office'),
      prefill: {},
      utm: {},
    });
    isOfficeCalendlyLoaded.value = true;
  } 
  
  if (type === 'virtual') {
    Calendly.initInlineWidget({
      url: virtualUrl,
      parentElement: document.getElementById('calendly_virtual'),
      prefill: {},
      utm: {},
    });
    isVirtualCalendlyLoaded.value = true;
  }

  return true;
};

const setupCalendly = (type) => {
  const wait_count = 15;
  const wait_secs = 1000;
  let intervalCount = 1;

  const checkInterval = setInterval(() => {
    if (mountCalendly(type)) {
      clearInterval(checkInterval);
    }

    if (intervalCount >= wait_count) {
      clearInterval(checkInterval);
    }

    intervalCount++;
  }, wait_secs);
};

const isCalendlyEvent = (e) => {
  return e.origin === "https://calendly.com" && e.data.event && e.data.event.indexOf("calendly.") === 0;
};

const attachCalendlyListener = () => {
  window.addEventListener("message", (e) => {
    if (isCalendlyEvent(e)) {
      if (e.data.event === 'calendly.event_type_viewed' && !is_event_type_viewed.value) {
        $appointmentCreationGtag();
        is_event_type_viewed.value = true;
      }

      if (e.data.event === 'calendly.event_scheduled' && !is_event_scheduled.value) {
        is_event_scheduled.value = true;
        $appointmentSucessGtag();
      }
    }
  });
};

onMounted(() => {
  $appointmentInitiateGtag();
  attachCalendlyListener();
});
</script>



<style scoped>
.largesvg {
    transform: scale(1.3);
}
.spinner{
  color:#668b84;
/*    height: 80vh; */
}
#calendly_office{
  width: 100%;
  height: 700px;
}

#calendly_virtual{
  width: 100%;
  height: 700px;
}
.main_title {
  margin-bottom: 4%;
}
.main_title h1 {
  font-size: 40px;
  text-align: center;
  padding-bottom: 2%;
}
.main_title p {
  text-align: center;
  color: #6a6161;
  font-size: 16px;
  text-transform: capitalize;
}
.main_title p span {
  font-style: italic;
}
.appoint_type {
  text-align: center;
}
.appoint_type_block {
  width: 80%;
  margin: 5% auto;
}
.appoint_type h3 {
  font-size: 30px;
}
.appoint_type p {
  color: #6a6161;
  font-size: 14px;
  padding: 5% 4%;
}
.appoint_type button {
  max-width: 280px;
  margin: 0 auto;
}
.services_block {
  padding: 3% 0 0;
  margin-bottom: 5%;
}
.services_block h2 {
  font-size: 40px;
  text-align: center;
  margin-bottom: 3%;
}
.services_block h4 {
  text-align: center;
  font-size: 22px;
  min-height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.services_block p {
  color: #6a6161;
  text-align: center;
}

.services_block p a{
  color: var(--green);
  text-decoration: underline;
}
.title_block{
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.modal-header {
  border-bottom: none  !important;
}
.title_block span {
  cursor: pointer;
}
.title_block h3 {
  font-size: 20px;
}
@media(max-width: 1200px){
  .appoint_type_block {
      width: 100%;
  }
}
@media(max-width: 992px){
  .appoint_type p{
      padding: 7% 0;
      min-height: 135px;
  }

  .main_title h1 {
      font-size: 32px;
  }
  .appoint_type h3{
      font-size: 28px;
  }
  .services_block h2{
      font-size: 32px;
      margin-bottom: 5%;
  }
  .services_block h4{
      font-size: 22px;
      min-height: 53px;
  }
  .services_block h4 br{
      display: none;
  }
}
@media(max-width: 767px){
  .appoint_type p{
      min-height: auto;
  }
  .main_title h1{
      font-size: 32px;
  }
  .main_title p{
      font-size: 16px;
  }
 
  
  .appoint_type_block{
      width:100%;
      margin: 7% 0 15%;
  }
  .appoint_type h3 {
      font-size: 24px;
  }
  .appoint_type {
      margin: 10% 0 0;
  }
  .services_block h4{
      font-size: 24px;
      min-height: auto;
  }
  .service_box {
      margin-bottom: 12%;
  }
  .services_block h2 {
      font-size: 32px;
      margin-bottom: 10%;
  }
 
}
</style>